import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Description = function Description(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return children ? /*#__PURE__*/React.createElement(Text, {
    className: cn('description', className),
    color: "grey60",
    size: "size5-r-l",
    "data-t-id": "components-Description"
  }, children) : null;
};